import React from 'react';

import { Card, CardContent, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function CardMobile({ data, cells }) {
  return (
    <Card>
      <CardContent>
        <S.Warrper>
          {cells.map((cell) => (
            <div key={Math.random()}>
              <Typography variant="body2">{cell.label}</Typography>
              <Typography>{data[cell.id] ?? ''}</Typography>
            </div>
          ))}
        </S.Warrper>
      </CardContent>
    </Card>
  );
}

CardMobile.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};
